export default __webpack_public_path__ + "static/media/template-field.bee11400.svg";